import React, { type FC } from 'react'
import ScrollableAnchor from 'react-scrollable-anchor'
import {
  CategoryTabbedContent,
  CategoryTabbedContentProps
} from '../../category-tabbed-content'
import { StoryblokProductComponentProps } from '../../storyblok/storyblok-product-component'

type ProductDetails = StoryblokProductComponentProps['productDetails'][number]

interface ProductFAQProps {
  anchor: string;
  faq?: CategoryTabbedContentProps['tabs'];
  legacyFaq?: ProductDetails['faqs'];
}

export const ProductFAQ: FC<ProductFAQProps> = (props) => {
  const { anchor, faq, legacyFaq } = props
  const tabs = faq ? faq : mapLegacyFaq(legacyFaq)

  if (!tabs) return null

  return (
    <ScrollableAnchor id={anchor}>
      <div>
        <CategoryTabbedContent
          title="FAQ"
          subtitle="Choose a category"
          tabs={tabs}
        />
      </div>
    </ScrollableAnchor>
  )
}

const mapLegacyFaq = (
  faq: ProductDetails['faqs'] | undefined
): CategoryTabbedContentProps['tabs'] | undefined => {
  if (!faq) return

  return [
    {
      _uid: 'product-faq-general',
      name: 'General',
      content: [
        {
          items: faq.map((faqItem) => ({
            _uid: faqItem._uid,
            title: faqItem.question,
            text: faqItem.answer
          }))
        }
      ]
    }
  ]
}
